import { useDeleteEntityApi } from '@/common/api/deleteEntityApi';
import { useOutboundDeliveryStore } from '../stores/outboundDeliveryStore';

export function useDeleteOutboundDeliveryApi() {
  const store = useOutboundDeliveryStore();

  return useDeleteEntityApi({
    url: 'delivery/outbound',
    translate: (t) => t.outboundDelivery.actions.delete,
    async processOk(request) {
      store.remove(request.id);
      return Promise.resolve({
        ok: true,
      });
    },
  });
}
